import { Button, Modal } from '@getinapp/appetizer';
import * as S from './styles';

export type PriorityModalProps = {
  isModalVisible: boolean;
  setIsModalVisible: (isModalVisible: boolean) => void;
};

export const PriorityModal = ({
  isModalVisible,
  setIsModalVisible,
}: PriorityModalProps) => {
  const handleCloseModal = () => setIsModalVisible(false);

  return (
    <S.Modal width="15%" title="" isOpen={isModalVisible} onRequestClose={null}>
      <p>
        No caso de você ter <b>prioridade por lei</b>, por favor procurar a
        recepção.
      </p>
      <S.WrapperButtons>
        <Button variant="outline" onClick={handleCloseModal}>
          Não sou prioridade por lei
        </Button>
      </S.WrapperButtons>
    </S.Modal>
  );
};
